import script from "./HomeViewBi.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeViewBi.vue?vue&type=script&setup=true&lang=js"

import "./HomeViewBi.vue?vue&type=style&index=0&id=29fe936e&lang=css"

const __exports__ = script;

export default __exports__